module.exports = __webpack_public_path__ + "static/dentons--dark-f5ad39c192e0cd57743f6bd073ffd785.png";